module.exports = __webpack_public_path__ + "static/media/times.4ac3a630.svg";